<template>
<div class="large-container">
	<Tabs v-model="tabName" @on-click="tabChange" v-if="companyUpdated">
		<TabPane label="保单" name="Policy">
			<keep-alive>
				<Policy v-if="tabName=='Policy'" ref="Policy" :forceFlag="forceFlag" :editedFlag="editedFlag"></Policy>
			</keep-alive>
		</TabPane>
		<TabPane label="批改记录" name="correctionRecord">
			<keep-alive>
				<CorrectionRecord v-if="tabName=='correctionRecord'" ref="correctionRecord"></CorrectionRecord>
			</keep-alive>
		</TabPane>
	</Tabs>
</div>
</template>
<script>
import Policy from './list/Policy'
import CorrectionRecord from './list/correctionRecord'
import Qs from 'qs'
export default {
	components:{Policy,CorrectionRecord},
	data () {
		return {
			tabName: 'Policy',
			companyUpdated:false,
			forceFlag: false,
			editedFlag: false
		}
	},
	created () {
		this.updateBindCompany()
		if(this.$route.query.tab){
			this.tabName=this.$route.query.tab
		}
	},
	methods: {
		// 更新绑定的公司
		updateBindCompany(){
			this.$axios.post('/employment/policy/bindUser.all').then(res=>{
				if(res.code==10000000){
					this.forceFlag = res.data.forceFlag;
					this.editedFlag = res.data.editedFlag;
					this.companyUpdated=true
				}else if(res.code==10000012){
					if(location.href&&location.href.indexOf('/common.html#/login')==-1){
						window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
					}
				}else{
					this.$Modal.error({
						title:'提示',
						content:res.msg,
						okText:'返回产品专区',
						onOk:()=>{
							// location.href="/haierProduct.html#/"
							location.href="/company"
						}
					})
				}
			})
		},
		tabChange (value) {
			let query={
				...this.$route.query,
				tab:value
			}
			this.tabName=value;
			this.$router.replace(`/flexible-employer?${Qs.stringify(query)}`)
			this.$nextTick(()=>{
				if(this.$refs[this.tabName]){
					this.$refs[this.tabName].search()
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/flexibleEmployer/Index.vue